<template>
  <b-container class="pricing-cards">
    <h2>Pricing</h2>
    <b-row>
      <b-col md="12" lg="4" v-for="item in priceList" :key="item.id">
        <div class="card box-shadow">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">{{item.title}}</h4>
          </div>
          <div class="card-body">
            <small class="mini-top">{{item.mini}}</small>
            <h1 class="card-title pricing-card-title">{{item.price}}</h1>
            <ul class="list-unstyled mt-3 mb-4">
              <li v-for="feature in item.features">{{feature}}</li>
            </ul>
            <div v-bind:class="{'force-bottom': item.forceBottom}">
              <a v-bind:href="item.href">
                <button type="button" class="btn btn-lg btn-block btn-outline-primary">Book Now!</button>
              </a>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'pricing',
  data () {
    return {
      priceList: [
        // {
        //   id: 'portrait',
        //   title: 'Portrait/Senior',
        //   price: '$200',
        //   href: 'mailto:photographer@alysonsivek.com?subject=Portrait%20Session',
        //   features: [
        //     '1.5 - 2 hour session',
        //     'Up to two outfit changes',
        //     '25 - 30 high resolution images in an online gallery with copyright release'
        //   ]
        // },
        {
          id: 'couple',
          title: 'Couple',
          price: '$250',
          href: 'mailto:photographer@alysonsivek.com?subject=Engagement%20Session',
          features: [
            '1.5 - 2 hour session',
            'Up to two outfit changes',
            '25 - 30 high resolution images in an online gallery with copyright release'
          ]
        },
        {
          id: 'family',
          title: 'Family',
          price: '$270',
          href: 'mailto:photographer@alysonsivek.com?subject=Family%20Session',
          features: [
            '1.5 - 2 hour session',
            'Up to two outfit changes',
            '40 - 45 high resolution images in an online gallery with copyright release'
          ]
        },
        {
          id: 'wedding',
          title: 'Wedding',
          mini: 'starting at',
          price: '$1500',
          href: 'mailto:photographer@alysonsivek.com?subject=Wedding',
          forceBottom: true,
          features: [
            'Book with an engagement (couple) session for a discount!'
          ]
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-photos {
  margin-top: 2em;
}
.main-photos .row > div {
  padding: 0;
}
.main-photos img {
  width: 100%;
  height: 100%;
}
.pricing-cards h2 {
  margin: 1em;
  text-transform: uppercase;
}
.pricing-cards .row > div {
  margin-bottom: 1em;
}
.pricing-cards .card {
  height: 100%;
}
.pricing-cards .card-body {
  position: relative;
  min-height: 240px;
}
.pricing-cards .card-body li:first-child {
  border-top: 1px solid #ddd;
}
.pricing-cards .card-body li {
  text-align: left;
  padding: 1em 0;
  border-bottom: 1px solid #ddd;
}
.pricing-cards .card-body button {
  text-decoration: none;
}
.pricing-cards .card-body .mini-top {
  position: absolute;
  top: 3px;
  left: 0;
  right: 0;
}

.force-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/Pricing.vue